import { Platform } from 'react-native'
import { universes } from './universeConfig'

export function isUniverse(name) {
  const universe = universes.find(
    (universe) => universe.name === name?.toLowerCase()
  )
  return !!universe
}

export function getUniverseId(name) {
  const universe = universes.find(
    (universe) => universe.name === name?.toLowerCase()
  )
  return universe?.id
}

export function extractUniverseFromWeb() {
	if (Platform.OS !== 'web') return null

	const pathSegments = window.location.href.split('/')
	const universeIndex = pathSegments.indexOf('u') + 1

	if (universeIndex > 0 && pathSegments[universeIndex]) {
		return pathSegments[universeIndex].toLowerCase()
	}

	return null
}

export function getUniverseConfig(name) {
	const target = name || extractUniverseFromWeb()

	const universe = universes.find((universe) => {
		return universe.name === target?.toLowerCase()
	})

	return universe
}

export function getUniverseConfigById(id) {
  const universe = universes.find((universe) => universe.id === id)
  return universe
}